import api from "./axios";

export const addAttachmentApi = (id, data) =>
  api.post(`/leads/${id}/attachments`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteAttachmentApi = (leadId, attachmentId) =>
  api.delete(`/leads/${leadId}/attachments/${attachmentId}`);
